import WorksFilterToggle from "./worksFilterToggle"

// Progressive enhancement over the plain <a> filter/agency links: instead of
// letting the browser navigate, fetch the target page and swap in just the
// bits that change server-side (filters/toggles + the grid), then push the
// new URL. Falls back to a normal navigation if anything looks wrong.
class WorksFilterHandler {
  constructor(root = document) {
    this.container = root.querySelector(".index-works")
    if (!this.container) return

    this.container.addEventListener("click", event => this.onClick(event))
    window.addEventListener("popstate", () => this.navigate(location.href, false))
  }

  onClick(event) {
    if (event.defaultPrevented || event.button !== 0) return
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    const link = event.target.closest(".index-works__filter[href], .index-works__agency[href]")
    if (!link) return

    event.preventDefault()
    this.navigate(link.href)
  }

  async navigate(url, pushState = true) {
    try {
      const response = await fetch(url)
      if (!response.ok) throw new Error("bad response")

      const html = await response.text()
      const doc = new DOMParser().parseFromString(html, "text/html")

      const nextTop = doc.querySelector(".index-works__top")
      const nextGrid = doc.querySelector(".index-works__grid")
      const currentTop = this.container.querySelector(".index-works__top")
      const currentGrid = this.container.querySelector(".index-works__grid")

      if (!nextTop || !nextGrid || !currentTop || !currentGrid) throw new Error("markup mismatch")

      currentTop.replaceWith(nextTop)
      currentGrid.replaceWith(nextGrid)
      document.title = doc.title

      if (pushState) history.pushState(null, "", url)

      // Toggle buttons/panels were just replaced along with __top, so their
      // listeners are gone — re-bind against the fresh nodes.
      new WorksFilterToggle(document)
    } catch {
      window.location.href = url
    }
  }
}

export default WorksFilterHandler
